var _path, _path2, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRegisterConfirm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 95,
    viewBox: "0 0 94 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47 26C35.1259 26 25.5 35.6259 25.5 47.5C25.5 59.3742 35.1259 69 47 69C58.8742 69 68.5 59.3742 68.5 47.5C68.5 35.6259 58.8742 26 47 26ZM20.5 47.5C20.5 32.8645 32.3645 21 47 21C61.6357 21 73.5 32.8645 73.5 47.5C73.5 62.1356 61.6356 74 47 74C32.3645 74 20.5 62.1357 20.5 47.5Z",
    fill: "#CBAB4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.4344 40.3989C60.4107 41.3752 60.4107 42.9581 59.4344 43.9344L46.1011 57.2677C45.1248 58.244 43.5419 58.244 42.5656 57.2677L34.5656 49.2677C33.5893 48.2914 33.5893 46.7085 34.5656 45.7322C35.5419 44.7559 37.1248 44.7559 38.1011 45.7322L44.3333 51.9644L55.8989 40.3989C56.8752 39.4225 58.4581 39.4225 59.4344 40.3989Z",
    fill: "#CBAB4F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 93,
    height: 93,
    rx: 46.5,
    stroke: "#D7E2ED"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterConfirm);
export default __webpack_public_path__ + "static/media/register-confirm.a87e94b839f260458df5063663e34246.svg";
export { ForwardRef as ReactComponent };